import { Layout } from '@taxdown/piccolo-web';
import QuizLoaderBanner from 'Containers/Datagathering/components/QuizLoaderBanner';
import OneColLayout from 'Components/Layouts/OneColLayout';
import QuizRouteHandler from '../QuizRouteHandler';

const QuizMain = (): JSX.Element => {
  return (
    <OneColLayout>
      <Layout.Wrap fullWidth>
        <QuizLoaderBanner />
        <QuizRouteHandler />
      </Layout.Wrap>
    </OneColLayout>
  );
};

export default QuizMain;
